import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {pairwise, startWith} from "rxjs/operators";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-warehouse-step-preview',
    templateUrl: './warehouse-step-preview.component.html',
    styleUrls: ['./warehouse-step-preview.component.scss'],
    standalone: false
})
export class WarehouseStepPreviewComponent implements OnInit {
  @Input() step: any;
  @Input() model: any = {};
  @Input() form: any = {};
  @Output() callback = new EventEmitter<any>(true);

  public warehouse: any = {};
  public wareHouseDetail: any = {};

  // @ts-ignore
  private warehouseSubscription: Subscription;
  // @ts-ignore
  private warehouseDetailSubscription: Subscription;



  constructor() {
  }


  ngOnInit(): void {

    this.model = this.model?.model;
    this.warehouse =   this.form.get('step01').get('wareHouse').getRawValue()?.value;
    this.wareHouseDetail =  this.form.get('step02').get('wareHouseDetail').getRawValue()?.value;
    this.initSubscriptions();

  }
  initSubscriptions(){
    this.warehouseSubscription = this.form.get('step01').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.warehouse = next ?.wareHouse;
      });

    this.warehouseDetailSubscription = this.form.get('step02').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.wareHouseDetail = next ?.wareHouseDetail;
      });
  }

  ngOnDestroy(){
    // prevent memory leak when component destroyed
    this.warehouseSubscription.unsubscribe();
    this.warehouseDetailSubscription.unsubscribe();
  }

}
